import React from "react";

function Footer() {
  return (
    <footer style={{ textAlign: "center", color: "grey" }}>
      <p>&copy; {new Date().getFullYear()} build with React by Aniq Aqil</p>
    </footer>
  );
}

export default Footer;
